import { assertNever } from '../assert/assertNever.js'
import { SparkDomain } from '../types/SparkDomain.js'

export interface DrpcRpcUrlParams {
  domain: SparkDomain
  drpcApiKey: string
}

export function getDrpcRpcUrl({ domain, drpcApiKey }: DrpcRpcUrlParams): string {
  switch (domain) {
    case 'mainnet':
      return `https://lb.drpc.live/ethereum/${drpcApiKey}`
    case 'base':
      return `https://lb.drpc.live/base/${drpcApiKey}`
    case 'gnosis':
      return `https://lb.drpc.live/gnosis/${drpcApiKey}`
    case 'arbitrum':
      return `https://lb.drpc.live/arbitrum/${drpcApiKey}`
    case 'optimism':
      return `https://lb.drpc.live/optimism/${drpcApiKey}`
    case 'worldchain':
      return `https://lb.drpc.live/worldchain/${drpcApiKey}`
    case 'unichain':
      return `https://lb.drpc.live/unichain/${drpcApiKey}`
    case 'avalanche':
      return `https://lb.drpc.live/avalanche/${drpcApiKey}`
    case 'sepolia':
      return `https://lb.drpc.live/sepolia/${drpcApiKey}`
    case 'baseSepolia':
      return `https://lb.drpc.live/base-sepolia/${drpcApiKey}`
    default:
      assertNever(domain)
  }
}
